import confirm from './confirm/index'
import alert from './alert/index'
import modal from './modal/index'
import toast from './toast'
import loading from './loading/index'
const install = function(Vue) {
  //注册全局组件
  Vue.component(confirm.name, confirm)
  Vue.prototype.$confirm = confirm

  Vue.component(alert.name, alert)
  Vue.prototype.$alert = alert

  Vue.component(modal.name, modal)
  Vue.prototype.$modal = modal

  Vue.component(toast.name, toast)
  Vue.prototype.$toast = toast

  Vue.component(loading.name, loading)
  Vue.prototype.$loading = loading;
}
export default install



// WEBPACK FOOTER //
// ./src/plugins/index.js